export { default } from './BoxPlot.component';
export type { BoxPlotProps, BoxPlotData } from './BoxPlot.component';
